module.exports = __webpack_public_path__ + "img/bg-04.d49caa7b.jpg";